import React from 'react';
import { useEffect, useState } from "react";

import { Container } from 'react-bootstrap';
import { useLocation } from "react-router-dom";

// import Breadcrumbs from '../components/Breadcrumbs';
import WatchlistSchemeSubstitute from '../features/schemes/WatchlistSchemeSubstitute';

export default function UserSchemesWatchListSubstitute({ filters = []}) {
  const location = useLocation();
  const [watchListURL, setWatchListURL] = useState('/get-watchlist-scheme-substitute');

  const watchlistParam = (location.state?.watchlistName) ? {'watchlistName' : (location.state?.watchlistName) }: null

  useEffect(() => {
    if (!watchlistParam) {
      setWatchListURL('/get-watchlist-scheme-substitute');
      return;
    }
    setWatchListURL('/get-watchlist-scheme-substitute')
    return;
  }, []);

  return (
    <div className="container-fluid" >
      <WatchlistSchemeSubstitute urlParams={watchlistParam} apiURL={watchListURL} filters={filters} 
                     schemeListTitle="User's Watchlist Schemes & Probable Substitute Schemes"/>
    </div>
  );
}